// Set an interval that cancels after being called a set number of times
export default function (func, duration, times) {
  let intervalId = null;
  let timesCalled = 0;
  const f = function () {
    if (++timesCalled > times) {
      window.clearInterval(intervalId);
    } else {
      func();
    }
  };
  intervalId = window.setInterval(f, duration);
}
